import { SET_WIDTH } from "./types";

export const setWidth = input => {
  return function(dispatch) {
    dispatch({ type: SET_WIDTH, payload: input });
  };
};
